import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { MaxBrainExperience } from './experience.model';

export class ExperienceStateModel extends EntityStateModel<MaxBrainExperience> {}
